import {calculateDistanceBetweenLatLngs} from "@irati/geolocation/src/helpers/geometry"
import {LatLng, BoundingBox} from "@irati/geolocation/src/types"

import {MapLocation, MapCard} from "../../types"

interface MapCardsAndLocations {
  cards: MapCard[],
  locations: MapLocation[]
}

/**
 * Finds the index of the card that represents the requested deal UUID
 */
const getCardIndex = (cards: MapCard[], dealUuid: string): number => cards.findIndex((card) => card.deal.uuid === dealUuid)

/**
 * Sorts an array of locations by their proximity to a certain location (sorts the array in-place)
 */
const sortLocationsByProximity = (locations: LatLng[], latLng: LatLng): void => {
  locations.sort(({lat: latA, lng: lngA}, {lat: latB, lng: lngB}) => {
    const locationADistFromUser = calculateDistanceBetweenLatLngs({lat: latA, lng: lngA}, latLng)
    const locationBDistFromUser = calculateDistanceBetweenLatLngs({lat: latB, lng: lngB}, latLng)
    return locationADistFromUser < locationBDistFromUser ? -1 : 1
  })
}

/**
 * Formats the deals data into a format that can be used by the searchAllByLocation page for the Cards
 */
// @todo: Create a deal interface
const prepareMapCards = (deals: any[], userLatLng: LatLng, mapCenterLatLng: LatLng): MapCard[] => {
  const hash = new Map()
  deals.map((deal) => {
    const {uuid, location} = deal
    const data = hash.get(uuid) || {deal, locations: []}
    data.locations.push(location)
    hash.set(uuid, data)
  })

  return Array.from(hash)
    .map(([dealUuid, {deal, locations}]) => {
      let mapCenterProximity = 0
      if (mapCenterLatLng) {
        sortLocationsByProximity(locations, mapCenterLatLng)
        mapCenterProximity = calculateDistanceBetweenLatLngs(locations[0], mapCenterLatLng)
      }
      let proximityMeters = 0
      if (userLatLng) {
        sortLocationsByProximity(locations, userLatLng)
        proximityMeters = calculateDistanceBetweenLatLngs(locations[0], userLatLng)
      }
      return {
        key: dealUuid,
        proximityMeters,
        mapCenterProximity,
        deal,
        locations
      }
    })
    .sort((a, b) => (a.mapCenterProximity < b.mapCenterProximity ? -1 : 1))
    .map((deal, index) => {
      return {
        ...deal,
        number: index + 1
      }
    })
}

/**
 * Formats the deals data into a format that can be used by the searchAllByLocation page for the Map
 */
// @todo: Create a deal interface
const prepareMapLocations = (deals: any[], cards: MapCard[]): MapLocation[] => {
  return deals.map((deal) => {
    const {location, uuid: dealUuid} = deal
    const {lat, lng, uuid: locationUuid} = location
    const index = getCardIndex(cards, dealUuid)
    return {
      key: locationUuid,
      lat,
      lng,
      index,
      number: index + 1,
      isActive: false,
      showDetails: false,
      zIndex: 1,
      deal
    }
  })
}

export const convertBoundingBoxStringToBoundingBox = (boundingBoxString: string): BoundingBox | number[] => {
  const arr = boundingBoxString ? boundingBoxString.split(",") : []
  return arr.map((item) => parseFloat(item))
}

/**
 * Formats the deals data into a format that can be used by the searchAllByLocation page for both Cards and the Map locations
 */
// @todo: Create a deal interface
export const prepareMapCardsAndLocations = (deals: any[], userLatLng: LatLng, mapCenterLatLng: LatLng): MapCardsAndLocations => {
  const cards = prepareMapCards(deals, userLatLng, mapCenterLatLng)
  const locations = prepareMapLocations(deals, cards)

  return {
    cards,
    locations
  }
}
